import { REACT_APP_API } from '../../config'
import axios from 'axios'

export async function getCarmuvRequirements() {
    try {
        const response = await axios.get(`${REACT_APP_API}/api/carmuvRequirements`)
        if (response.status === 200) {
            return response.data
        }
        return null
    } catch (error) {
        console.log(`Error getCarmuvRequirements `, error)
        return error
    }

}